import React, { useState } from 'react';
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Button,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import ErrorBoundary from 'components/ErrorBoundary';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

ChartJS.register(ArcElement, Tooltip, Legend);

const plugin = {
  beforeInit(chart) {
    console.log('be');
    // Get reference to the original fit function
    const originalFit = chart.legend.fit;

    // Override the fit function
    chart.legend.fit = function fit() {
      // Call original function and bind scope in order to use `this` correctly inside it
      originalFit.bind(chart.legend)();
      // Change the height as suggested in another answers
      this.height = this.height + 25;
    };
  },
};

export const options = {
  responsive: true,
  plugins: {
    tooltip: {
      callbacks: {
          label: function (d,t) {
          var xLabel = "Dispense Fee Revenue";
          var yLabel ='$' + d.formattedValue;
          return xLabel + ': ' + yLabel;
        },
      },
    },
    legend: {
      position: 'top',
      align: 'start',
      labels: {
        usePointStyle: true,
        pointStyle: 'rect',
        font: {
          weight: 'bold',
        },
      },
    },
    customCanvasBackgroundColor: {
      color: 'lightGreen',
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
  },
};


const RevenueMonthWidget = ({months,dispFee}) => {
  const [active, setActive] = useState('6');

  const data = {
    labels: months,
    datasets: [
      {
        label: 'Dispense Fee Revenue',
        data: dispFee,
        // borderColor: "#12545E",
        backgroundColor: 'rgb(18, 84, 94)',
      },
    ],
  };

  const handleActive = (title) => {
    setActive(title);
  };

  const getDate = () => {
     setActive("custom");
  }

  return (
    <ErrorBoundary>
      {/* <HorizontalBarChart /> */}
      <Card className='p-3 h-100'>
        <CardHeader className='border-0 bg-white px-0 pt-0'>
          <Row className='align-items-center'>
            <Col>
              <CardTitle className='f-20 font-weight-500'>
                Program Revenue
              </CardTitle>
            </Col>
            <Col xs='auto'>
              <Nav className='widget-tabs'>
                
              </Nav>
            </Col>
          </Row>
        </CardHeader>
        <CardBody className='dashboard-chart-body'>
          <Bar options={options} data={data} plugins={[plugin]}/>
          {/* <Line options={options} data={data} plugins={[plugin]} /> */}
         
          {/* <span>2022</span> */}
        
        </CardBody>
      </Card>
    </ErrorBoundary>
  );
};

export default RevenueMonthWidget;
